import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-employee-status',
  templateUrl: './employee-status.component.html',
  styleUrls: ['./employee-status.component.scss'],
})
export class EmployeeStatusComponent implements OnInit {
  @Input() status: string;
  constructor() {}

  statusClassName: string;
  statusLabel: string;

  ngOnInit(): void {
    this.assignStatusClass();
  }

  assignStatusClass() {
    if (this.status) {
      this.statusClassName = 'status-active';
      this.statusLabel = 'Active';
    } else {
      this.statusClassName = 'status-inactive';
      this.statusLabel = 'Inactive';
    }
  }
}
